var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"TreeNodeLink",class:_vm.cc,attrs:{"to":{params: {actor: _vm.actor.pathArr}, query: _vm.$route.query}}},[_vm._v("\n  "+_vm._s(_vm.actor.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }